/**
 * ParentFormModal — Модалка создания/редактирования родителя.
 *
 * При создании обязателен только email. Пароль генерируется автоматически.
 */
import React, { useState, useEffect } from 'react';
import { Modal, TextInput, Stack, Group, Button } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { createParent, updateParent } from '../../services/api/parentsService';

const ParentFormModal = ({ opened, onClose, parent = null, onSuccess }) => {
  const isEdit = !!parent;

  const [form, setForm] = useState({ email: '', first_name: '', last_name: '', phone: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (opened) {
      if (parent) {
        setForm({
          email: parent.email || '',
          first_name: parent.first_name || '',
          last_name: parent.last_name || '',
          phone: parent.phone || '',
        });
      } else {
        setForm({ email: '', first_name: '', last_name: '', phone: '' });
      }
    }
  }, [opened, parent]);

  const handleSubmit = async () => {
    if (!form.email.trim()) {
      notifications.show({ title: 'Ошибка', message: 'Email обязателен', color: 'red' });
      return;
    }

    setLoading(true);
    try {
      const data = {
        email: form.email.trim(),
        ...(form.first_name.trim() && { first_name: form.first_name.trim() }),
        ...(form.last_name.trim() && { last_name: form.last_name.trim() }),
        ...(form.phone.trim() && { phone: form.phone.trim() }),
      };

      if (isEdit) {
        await updateParent(parent.id, data);
        notifications.show({ title: 'Успешно', message: 'Данные родителя обновлены', color: 'green' });
      } else {
        await createParent(data);
        notifications.show({ title: 'Успешно', message: 'Родитель создан', color: 'green' });
      }

      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      notifications.show({ title: 'Ошибка', message: err.message, color: 'red' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={isEdit ? 'Редактировать родителя' : 'Добавить родителя'}
      centered
    >
      <Stack gap="sm">
        <TextInput
          label="Email"
          placeholder="email@example.com"
          required
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          radius="xl"
        />
        <Group grow>
          <TextInput
            label="Фамилия"
            placeholder="Иванов"
            value={form.last_name}
            onChange={(e) => setForm({ ...form, last_name: e.target.value })}
            radius="xl"
          />
          <TextInput
            label="Имя"
            placeholder="Иван"
            value={form.first_name}
            onChange={(e) => setForm({ ...form, first_name: e.target.value })}
            radius="xl"
          />
        </Group>
        <TextInput
          label="Телефон"
          placeholder="+7 999 123-45-67"
          value={form.phone}
          onChange={(e) => setForm({ ...form, phone: e.target.value })}
          radius="xl"
        />
        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={onClose}>Отмена</Button>
          <Button onClick={handleSubmit} loading={loading}>
            {isEdit ? 'Сохранить' : 'Создать'}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ParentFormModal;
